import { render, staticRenderFns } from "./posChainIndex.vue?vue&type=template&id=69f388f7&"
import script from "./posChainIndex.vue?vue&type=script&lang=js&"
export * from "./posChainIndex.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports